import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import manualPDF from "../assets/Manual_Genius_Menu.pdf";
import { useUser } from "../context/UserContext";
import "../css/SidebarMenu.css";

export default function SidebarMenu({ open, onClose, headerHeight = 64 }) {
  const [openManual, setOpenManual] = useState(false);
  const [openAdmin, setOpenAdmin] = useState(false);
  const drawerRef = useRef(null);
  const navigate = useNavigate();
  const { user, userDecoded } = useUser();
  const isDev = user && userDecoded()?.perfis?.includes("DESENVOLVEDOR");

  const navAdmin = (path) => { navigate(path); onClose?.(); };

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  useEffect(() => {
    if (!open) return;
    let startX = null;
    const el = drawerRef.current;

    const start = (e) => (startX = e.touches[0].clientX);
    const end = (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (dx < -60) onClose?.(); 
      startX = null;
    };

    el?.addEventListener("touchstart", start, { passive: true });
    el?.addEventListener("touchend", end, { passive: true });
    return () => {
      el?.removeEventListener("touchstart", start);
      el?.removeEventListener("touchend", end);
    };
  }, [open, onClose]);

  const handleWhatsAppClick = () => {
    const phoneNumber = "5511948214839";
    const message = encodeURIComponent("Olá! Gostaria de mais informações sobre o Genius Menu.");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };
  
  return createPortal(
    <>
      <div
        className={`sidebar-backdrop ${open ? "open" : ""}`}
        style={{ "--header-height": `${headerHeight}px` }}
        onClick={onClose}
        aria-hidden={!open}
      />

      <aside
        ref={drawerRef}
        className={`sidebar-drawer ${open ? "open" : ""}`}
        style={{ "--header-height": `${headerHeight}px` }}
        role="dialog"
        aria-modal="true"
        aria-labelledby="drawer-title"
        aria-hidden={!open}
      >
        <div className="sidebar-head">
          <h2 id="drawer-title" className="sidebar-title">Menu</h2>
        </div>


        <nav className="sidebar-nav">

          {isDev && (
            <>
              <button
                type="button"
                className={`manual-btn ${openAdmin ? "is-open" : ""}`}
                onClick={() => setOpenAdmin((v) => !v)}
                aria-expanded={openAdmin}
                aria-controls="submenu-admin"
              >
                <span>Administração</span>
                <span className="manual-icon" aria-hidden="true">
                  {openAdmin ? "−" : "+"}
                </span>
              </button>
              <div id="submenu-admin" className={`submenu ${openAdmin ? "open" : ""}`}>
                <button className="submenu-link" onClick={() => navAdmin("/admin/restaurantes")}>
                  Restaurantes
                </button>
                <button className="submenu-link" onClick={() => navAdmin("/admin/usuarios")}>
                  Usuários
                </button>
                <button className="submenu-link" onClick={() => navAdmin("/admin/vinculos")}>
                  Vínculos
                </button>
              </div>
            </>
          )}

          <button
            type="button"
            className={`manual-btn ${openManual ? "is-open" : ""}`}
            onClick={() => setOpenManual((v) => !v)}
            aria-expanded={openManual}
            aria-controls="submenu-manual"
          >
            <span>Manual</span>
            <span className="manual-icon" aria-hidden="true">
              {openManual ? "−" : "+"}
            </span>
          </button>

          <div id="submenu-manual" className={`submenu ${openManual ? "open" : ""}`}>
            <a
              href={manualPDF}
              download="Manual-do-Usuario.pdf"
              className="submenu-link"
              onClick={onClose}
            >
              Baixar manual do usuário
            </a>
          </div>
        </nav>

        <footer className="sidebar-footer">
          <p className="sidebar-footer-powered">
            Powered by{" "}
            <a
              href="https://www.g2atech.com"
              target="_blank"
              rel="noopener noreferrer"
              className="sidebar-footer-link"
            >
              G2A Tech
            </a>
          </p>
          <p className="sidebar-footer-version">Versão 1.2.0</p>
          <button
            type="button"
            className="sidebar-footer-contact"
            onClick={handleWhatsAppClick}
          >
            Contate-nos
          </button>
        </footer>
        
      </aside>
    </>,
    document.body
  );
}
